import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class LogosSliderDesktop {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: true,
            pageDots: false,
            wrapAround: true,
            prevNextButtons: true,
            freeScroll: true,
            cellSelector: '.home-press__logos-group',
            cellAlign: 'center',
            // arrowShape: 'M10.826.922c-1.153.427-5.542 1.894-7.952 3.895C1.309 6.117.513 7.688.705 9.263c.303 2.488 2.376 4.606 5.285 6.203 3.404 1.87 7.932 3.127 10.102 4.272a2.001 2.001 0 0 0 1.866-3.538c-2.157-1.138-6.66-2.382-10.043-4.24-.943-.517-1.791-1.079-2.418-1.726-.428-.44-.754-.906-.821-1.455-.027-.217.201-.355.382-.543.331-.342.759-.658 1.228-.956 2.158-1.37 5.13-2.309 5.961-2.619 1.02-.38 1.324-1.07 1.371-1.178.375-.856.196-1.576-.383-2.185a2 2 0 0 0-2.409-.376Zm-.944 1.142c-.26.735-.097 1.366.382 1.91a1.999 1.999 0 0 1-.382-1.91Zm.009-.028-.005.015.008-.021-.003.006Z'
        };

        if(this.$el.length) {
            this._init();
            this._bindEvents();
        }
    }

    _init() {
        this.$slides = this.$el.find('.home-press__logos-item');
        this.slidesCount = this.$slides.length;

        if (document.body.clientWidth >= 992 && this.slidesCount > 12) {
            this.slider = new Flickity(this.$el[0], this.options);
        } else if (document.body.clientWidth >= 992 && this.slidesCount < 13) {
            // this._destroy();
        } else {
            this._destroy();
        }
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }
    
    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if (document.body.clientWidth >= 992 && this.slidesCount > 12) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options.optionsDesktop);
        } else if (document.body.clientWidth >= 992 && this.slidesCount < 12) {
            this._destroy();
        } else {
            this._destroy();
        }
    }
}

export default LogosSliderDesktop;